export default {
  endpoints: {
    stitchBackend: "http://localhost:8080",
    astraRedirect: "http://localhost:3000",
  },
  debug: true,
};
